import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Globals } from 'src/app/shared/globals/globals';
import { DeliveryDate, EnquiryHeaderItem } from 'src/app/shared/models/data/enquiry.model';

@Component({
  selector: 'app-modal-item-delivery-dates',
  templateUrl: './modal-item-delivery-dates.component.html',
  styleUrls: ['./modal-item-delivery-dates.component.scss']
})
export class ModalItemDeliveryDatesComponent implements OnInit {
  @Input() isMobile: boolean = false;
  @Input() theme: string = "silver";
  @Input() enquiryNo!: string;
  @Input() item!: EnquiryHeaderItem;

  @Output() onCancel = new EventEmitter<void>();

  constructor(public globals: Globals) {

  }

  ngOnInit(): void {
  }

  onCancelClick() {
    this.onCancel.emit();
  }

  formatWeeks(weeks: number): string {
    return `${weeks} week${weeks > 1 ? 's' : ''}`;
  }

  get isItdcrSource(): boolean {
    return this.item?.deliverySource?.toLowerCase() === 'itdcr';
  }

  getBaseDeliveryDisplay(deliveryDate: DeliveryDate): string {
    if (this.isItdcrSource) {
      return deliveryDate.deliveryWeekOfYear || '';
    }

    const weeks = deliveryDate.deliveryNumberOfWeeks;
    return weeks === undefined || weeks === null ? '-' : this.formatWeeks(weeks);
  }

  getExtraLeadTimeDisplay(): string {
    const extraLeadTime = this.item?.extraLeadTime;
    if (extraLeadTime === undefined || extraLeadTime === null) return '';
    return this.formatWeeks(extraLeadTime);
  }

  getTotalDeliveryDisplay(deliveryDate: DeliveryDate): string {
    if (this.isItdcrSource) {
      return deliveryDate.deliveryWeekOfYearWithExtraLeadTime || '';
    }

    const weeks = deliveryDate.deliveryNumberOfWeeksWithExtraLeadTime;
    return weeks === undefined || weeks === null ? '' : this.formatWeeks(weeks);
  }

}
